import * as React from 'react';

import { IconsAvailable } from '../../Components/Icon';
import HeadingWithButtons from '../../Components/HeadingWithButtons';

export interface ILayoutSidebarSecondaryProps {
    /** Column title */
    title: React.ReactNode;
    /** Icon for column title */
    icon?: IconsAvailable;
    /** className to append */
    className?: string;
    /** Content before heading */
    preContent?: React.ReactNode;
}

interface IState {
}

type Props = ILayoutSidebarSecondaryProps;

/**
 * Secondary column to be used inside LayoutSidebar
 */
class LayoutSidebarSecondary extends React.Component<Props, IState> {
    static displayName: string = 'LayoutSidebarSecondary';

    render () {
        return (
            <div className="layout-sidebar-secondary">
                {this.props.preContent && this.props.preContent}
                <HeadingWithButtons
                    title={this.props.title}
                    level={2}
                    icon={this.props.icon}
                />
                <div className="sticky">
                    {this.props.children}
                </div>
            </div>
        );
    }
}

export default LayoutSidebarSecondary;
